/* CardX Redesign – Warenkorb-Seitenleiste (Section Rendering API, ohne Bibliotheken) */
(() => {
  'use strict';

  const T = window.CXTheme;
  const CX = (window.CX = window.CX || {});
  const drawer = document.querySelector('[data-cx-cart-drawer]');
  if (!T || !drawer) return;

  const SECTION = 'cx-cart-drawer';
  const onCartPage = document.body.classList.contains('cx-tpl-cart');
  CX.cartDrawer = drawer.dataset.enabled === 'true' && !onCartPage;
  if (!CX.cartDrawer) return;

  const root = (CX.routes && CX.routes.root) || '/';
  const changeUrl = ((CX.routes && CX.routes.cartChange) || '/cart/change') + '.js';
  const openers = T.$$('[data-cx-cart-open]');
  const ctrl = T.panel(drawer, [], { focus: '.cx-cdrawer__head button' });
  let busy = false;

  const render = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#cx-cdrawer-inner');
    const current = drawer.querySelector('#cx-cdrawer-inner');
    if (fresh && current) current.replaceWith(fresh);
    T.initMediaTone(drawer);
    document.dispatchEvent(new CustomEvent('cx:cart:rendered'));
  };

  const refresh = async () => {
    try {
      const res = await fetch(root + '?sections=' + SECTION, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      render(data[SECTION]);
    } catch (e) {
      /* Fallback: Inhalt aus dem Seitenaufruf bleibt sichtbar */
    }
  };

  const open = () => ctrl.open();
  /* Erneut laden, wenn ein anderes Modul den Warenkorb geändert hat (z. B. CardX Rewards) */
  document.addEventListener('cx:cart:refresh', refresh);

  openers.forEach((link) => {
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', 'cx-cart-drawer');
    link.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey) return;
      event.preventDefault();
      open();
      refresh();
    });
  });

  document.addEventListener('cx:cart:added', (event) => {
    const data = event.detail || {};
    if (data.sections && data.sections[SECTION]) render(data.sections[SECTION]);
    else refresh();
    open();
  });

  const focusSelector = () => {
    const a = document.activeElement;
    if (!a || !drawer.contains(a)) return null;
    if (a.matches('[data-cx-line-step]')) return '[data-cx-line-step="' + a.dataset.cxLineStep + '"]';
    if (a.matches('[data-cx-line-qty]')) return '[data-cx-line-qty]';
    return null;
  };

  const change = async (line, quantity) => {
    if (busy) return;
    busy = true;
    const focusSel = focusSelector();
    const inner = drawer.querySelector('#cx-cdrawer-inner');
    if (inner) inner.setAttribute('aria-busy', 'true');
    drawer.classList.add('is-updating');
    try {
      const res = await fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line, quantity, sections: SECTION, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Die Menge konnte nicht geändert werden.');
      render(data.sections && data.sections[SECTION]);
      T.refreshCartCount(data.item_count);
      document.dispatchEvent(new CustomEvent('cx:cart:changed', { detail: { cart: data } }));
      /* Fokus an derselben Stelle wiederherstellen (Tastaturbedienung) */
      const sameLine = drawer.querySelector('[data-cx-line="' + CSS.escape(line) + '"]');
      let target = null;
      if (sameLine && focusSel) target = sameLine.querySelector(focusSel);
      if (target && target.disabled) target = sameLine.querySelector('[data-cx-line-qty]');
      if (!target) target = drawer.querySelector('.cx-cdrawer__head button');
      if (target && !drawer.contains(document.activeElement)) target.focus({ preventScroll: true });
    } catch (error) {
      T.toast('<span class="cx-toast__text">' + T.esc(error.message) + '</span>', 'error');
      refresh();
    } finally {
      busy = false;
      drawer.classList.remove('is-updating');
    }
  };

  drawer.addEventListener('click', (event) => {
    const lineEl = event.target.closest('[data-cx-line]');
    if (!lineEl) return;
    const input = lineEl.querySelector('[data-cx-line-qty]');
    const current = Number(input && input.value) || 0;
    const step = event.target.closest('[data-cx-line-step]');
    if (step) {
      const next = Math.max(0, current + Number(step.dataset.cxLineStep));
      const max = input && input.max !== '' ? Number(input.max) : Infinity;
      if (next > max) return;
      change(lineEl.dataset.cxLine, next);
    } else if (event.target.closest('[data-cx-line-remove]')) {
      change(lineEl.dataset.cxLine, 0);
    }
  });

  drawer.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cx-line-qty]');
    if (!input) return;
    const lineEl = input.closest('[data-cx-line]');
    let value = Math.max(0, Math.floor(Number(input.value) || 0));
    if (input.max !== '') value = Math.min(value, Number(input.max));
    change(lineEl.dataset.cxLine, value);
  });
})();